import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

const usePaymentModal = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [openPaymentModal, setOpenPaymentModal] = useState(false);
  const [selectedClientEmail, setSelectedClientEmail] = useState<string | null>(
    null
  );

  const handleClosePreselectedClient = () => {
    setOpenPaymentModal(false);
    setSelectedClientEmail(null);
    setSearchParams({});
  };

  useEffect(() => {
    if (searchParams.get('sendPaymentTo')) {
      const email = searchParams.get('sendPaymentTo');
      if (email) {
        setSelectedClientEmail(email);
        setOpenPaymentModal(true);
        setSearchParams({});
      }
    }
  }, [searchParams, setSearchParams]);

  return {
    openPaymentModal,
    selectedClientEmail,
    handleClosePreselectedClient,
  };
};

export default usePaymentModal;
